/* Decisions implementations as functions */

import HTTP from "./http.service";
import Plans from "./plans.service";
import Numbers from "./numbers.service";
import Storage from "./storage.service";
import Helpers from "../helpers/shared.helper";
import * as variables from '../variables';
import { isArray } from "rxjs/internal-compatibility";
import checkModule from "../views/shared/checkModule";
const { isSummaryKw, isSummaryKsa } = checkModule;
var Summaries = {
	vars: {
		tick: 0,
		loading: false,
		loadingExtras: false,
		prices: {
			number: 0,
			plan: 0,
			vat_percentage: 0
		}
	},
	response: null
};

Summaries.calculateTotalPrice = () => {
	let total_no_vat = 0;
	let vat_value = 0;
	let total_with_vat = 0;
	let summary = Storage.get("summary");

	if (summary) {
		let reservedNumber = summary["reserved_number"];
		let selectedPlan = summary["selected_bundle"];

		if (reservedNumber && selectedPlan && summary["prices"]) {
			let plan_price = summary["prices"]["plan"];
			let number_price = summary["prices"]["number"];
			total_no_vat = plan_price + number_price;
			let vat = summary["prices"]["vat_percentage"];
			let vat_percentage = parseFloat(vat, 10) / 100;
			total_with_vat = total_no_vat * (1.0 + vat_percentage);
			vat_value = total_no_vat * vat_percentage;
		}
	}
	return {
		total_no_vat: Helpers.formatNumber(total_no_vat),
		total_with_vat: Helpers.formatNumber(total_with_vat),
		vat_value: Helpers.formatNumber(vat_value)
	};
}

Summaries.isTotalPricesReady = () => {
	let summary = Storage.get("summary");
	if (summary) {
		let reservedNumber = summary["reserved_number"];
		let selectedPlan = summary["selected_bundle"];
		if (reservedNumber && selectedPlan && summary["prices"]) {
			Helpers.debug_payment("prices ready");
			return true;
		}
	}
	return false;
}

Summaries.getSummary = (callee = 'default') => {
	if (isSummaryKw) {
		Storage.set("errorSummaryAPI", true);
	}

	// return HTTP(config);
	let offerAppliedPromoId = Storage.get("offer_applied_promotion_id", true);
	let simActivationType = Storage.get("sim_activation_type", true);
	let deliveryMethod = "";
	if (isSummaryKsa) {

		switch (simActivationType) {
			case "has_esim":
			case "has_sim":
				// SelfActivation
				deliveryMethod = "SelfActivation";
				break;
			case "in_store_activation":
				// PayInStore
				deliveryMethod = "PayInStore";
				break;
			case "deliver_sim":
				// AskForDelivery
				deliveryMethod = "AskForDelivery";
				break;
			default:
				break;
		}
	}
	let config = {
		method: "get",
		url: !!simActivationType ? `/plans/summary?include_optional_promotions=true&delivery_method=${deliveryMethod}&random=` + Date.parse(new Date()) : "/plans/summary?include_optional_promotions=true&random=" + Date.parse(new Date()),
		headers: {
			"cache-control": "no-cache"
		}
	};
	if (offerAppliedPromoId?.length) {
		let promotionID = isArray(offerAppliedPromoId) ?
			offerAppliedPromoId.join(",") :
			offerAppliedPromoId;
		config = {
			method: "get",
			url: !!simActivationType ? `/plans/summary?include_optional_promotions=true&delivery_method=${deliveryMethod}&random=` + Date.parse(new Date()) + "&promotion_codes=" + promotionID : "/plans/summary?include_optional_promotions=true&random=" + Date.parse(new Date()) + "&promotion_codes=" + promotionID,
			headers: {
				"cache-control": "no-cache"
			}
		};
	}

	if (Storage.get("fetching_summary")) {
		return Storage.get("fetching_summary");
	}

	if (Storage.get('fetching_summary')) {
		Storage.set("fetching_summary", false);
		return HTTP(config);
	} else {
		let f = HTTP(config);
		Storage.set("fetching_summary", f);
		f.then(res => {
			Summaries.response = res.data;
			Storage.set("fetching_summary", false);
		}).catch(err => {
			Storage.set("fetching_summary", false);
		});
		return f;
	}

};

Summaries.getPlan = () => {
	return Plans.getSavedBundle(2);
};

Summaries.updateStreamExtras = (availablePromotion, removeExtras = false) => {
	if (!availablePromotion) return;

	let jsonObjectExtras = [{
		Value: removeExtras ? "" : availablePromotion.Type,
		Type: variables.CONTENT_SERVICE_TYPE

	}]
	return Plans.postPlanExtras(jsonObjectExtras).then(response => {
		return Summaries.getSummary().then(response => {
			let flags = Storage.get('flags');
			Summaries.vars["prices"]["vat_amount"] =
				response.data.vat_amount;
			Summaries.vars["prices"]["total_amount_vat_excluded"] =
				response.data.total_amount_vat_excluded;
			Summaries.vars["prices"]["total_amount_vat_included"] =
				response.data.total_amount_vat_included;

			Summaries.vars["extras"] = response.data.extras;

			if (response.data.number_details) {
				let number = response.data.number_details;
				Storage.set("reserved_number", number);

				Summaries.vars["reserved_number"] = number;

				let vanity_details = Summaries.vars["vanity_details"];
				if (vanity_details) {

					let VanityLevel = Numbers.getVanityLevelID(number);

					let detail = vanity_details["" + VanityLevel];
					detail["is_vanity_plan"] = true;

					let vanity_plan = Plans.getSinglePlanWithSpecs(detail);
					let price = detail["vanityPrice"];
					Summaries.vars["prices"]["number"] = price;

					Summaries.vars["vanity_plan"] = vanity_plan;

					Summaries.vars["vanity"] = detail;
				}
			}

			if (
				response.data.saved_plans &&
				response.data.saved_plans[0] &&
				response.data.saved_plans[0]["Plans"] &&
				response.data.saved_plans[0]["Plans"].length
			) {

				let selected_bundle = Plans.getSinglePlanWithSpecs(
					response.data.saved_plans[0]
				);
				Storage.set("selectedPlanSpecsIDs",
					Plans.getPlanIDs(response.data.saved_plans[0])?.split(',').sort().join(','));
				if (selected_bundle.ProductCode)
					Storage.set("selectedProduct", selected_bundle.ProductCode);
				let PredefinedPlans = Storage.get("PredefinedPlans");
				if (PredefinedPlans) {
				}

				let type = Plans.findPlanType(
					PredefinedPlans,
					selected_bundle
				);
				selected_bundle["bundle_type"] = type;

				Storage.set("selected_bundle", selected_bundle);

				Summaries.vars["selected_bundle"] = selected_bundle;

				Summaries.vars["prices"]["plan"] =
					selected_bundle["DiscountedPrice"];
				let business = JSON.parse(Storage.get('business', true));
				Summaries.vars["prices"]["vat_percentage"] =
					business["vat_percentage"];
			} else {
				if (flags.PlanSelected) {
					// @Todo print PAYG plan specs
					Storage.set("selected_bundle", []);
					Summaries.vars["selected_bundle"] = [];
				} else {
					Storage.set("selected_bundle", null);
					Summaries.vars["selected_bundle"] = null;
				}
			}

			Summaries.vars["tick"] = Summaries.vars["tick"] + 1;
			Summaries.vars["loading"] = false;
			Summaries.vars["loadaddStreamingServiceingExtras"] = false;
			Storage.set("summary", Summaries.vars);
		});
	}).catch(err => {
		Summaries.vars["tick"] = Summaries.vars["tick"] + 1;
		Summaries.vars["loading"] = false;
		Summaries.vars["loadingExtras"] = false;
		Storage.set("summary", Summaries.vars);
		return;
	})

};

Summaries.init = (callee = 'default') => {

	if (!Storage.get("PredefinedPlans") || !Storage.get("AvailablePlans")) {
		Plans.getPlans("Available");
	}

	Storage.get_obsrv("vanity_details").subscribe(data => {
		Summaries.vars["vanity_details"] = data;

		Storage.set("summary", Summaries.vars);

		if (data) {

			Storage.get_obsrv("AvailablePlans").subscribe(AvailablePlans => {
				if (AvailablePlans) {
					Plans.getPlans("Predefined");
				}
			});

			Storage.get_obsrv("PredefinedPlans").subscribe(PredefinedPlans => {
				if (PredefinedPlans) {

					let flags = Storage.get('flags');
					if (flags) {

						if (flags.NumberSelected) {
							Summaries.getSummary('init')
								.then(response => {
									Summaries.vars["prices"]["vat_amount"] =
										response.data.vat_amount;
									Summaries.vars["prices"]["total_amount_vat_excluded"] =
										response.data.total_amount_vat_excluded;
									Summaries.vars["prices"]["total_amount_vat_included"] =
										response.data.total_amount_vat_included;

									Summaries.vars["extras"] = response.data.extras;

									if (response.data.number_details) {
										let number = response.data.number_details;
										Storage.set("reserved_number", number);

										Summaries.vars["reserved_number"] = number;

										let vanity_details = Summaries.vars["vanity_details"];
										if (vanity_details) {

											let VanityLevel = Numbers.getVanityLevelID(number);

											let detail = vanity_details["" + VanityLevel];
											detail["is_vanity_plan"] = true;

											let vanity_plan = Plans.getSinglePlanWithSpecs(detail);
											let price = detail["vanityPrice"];
											Summaries.vars["prices"]["number"] = price;

											Summaries.vars["vanity_plan"] = vanity_plan;

											Summaries.vars["vanity"] = detail;
										}
									}

									if (
										response.data.saved_plans &&
										response.data.saved_plans[0] &&
										response.data.saved_plans[0]["Plans"] &&
										response.data.saved_plans[0]["Plans"].length
									) {

										let selected_bundle = Plans.getSinglePlanWithSpecs(
											response.data.saved_plans[0]
										);
										Storage.set("selectedPlanSpecsIDs",
											Plans.getPlanIDs(response.data.saved_plans[0])?.split(',').sort().join(','));
											Storage.set("selectedPlanPromotions",response.data.saved_plans[0]?.PlanPromotions);
										if (selected_bundle.ProductCode)
											Storage.set("selectedProduct", selected_bundle.ProductCode);

										let PredefinedPlans = Storage.get("PredefinedPlans");
										if (PredefinedPlans) {
										}

										let type = Plans.findPlanType(
											PredefinedPlans,
											selected_bundle
										);
										selected_bundle["bundle_type"] = type;

										Storage.set("selected_bundle", selected_bundle);

										Summaries.vars["selected_bundle"] = selected_bundle;

										Summaries.vars["prices"]["plan"] =
											selected_bundle["DiscountedPrice"];
										let business = JSON.parse(Storage.get('business', true));
										Summaries.vars["prices"]["vat_percentage"] =
											business["vat_percentage"];
									} else {
										if (flags.PlanSelected) {
											// @Todo print PAYG plan specs
											Storage.set("selected_bundle", []);
											Summaries.vars["selected_bundle"] = [];
										} else {
											Storage.set("selected_bundle", null);
											Summaries.vars["selected_bundle"] = null;
										}
									}

									Summaries.vars["tick"] = Summaries.vars["tick"] + 1;

									Storage.set("summary", Summaries.vars);
								})
								.catch(err => { });
						}
					}
					// })

				}
			});
		}
	});



	// Numbers.vanity_details();

	Storage.getOrfetch("vanity_details", Numbers.vanity_details)
		.then(data => {
			if (data["data"]) {
				Numbers.process_vanity_details(data.data);
			}
		})
		.catch(error => { });
};

Summaries.fetchSummaryDetails = () => {
	let config = {
		method: "get",
		url: "/plans/summary?include_optional_promotions=true&random=" + Date.parse(new Date()),
		headers: {
			"cache-control": "no-cache"
		}
	}
	return HTTP(config);
};

export default Summaries;